

export function loadMore(currentPage, itemForPage ) {
   let selectorItem = $('.video-container .videoItem-page.hidden');
   selectorItem.each(function(index,item) {
      if (index < itemForPage) {
         $(item).removeClass('hidden');
      }
   });
   isLoadMoreHidden(selectorItem.length, itemForPage);
}


window.loadMoreVideo = loadMore;


function isLoadMoreHidden(items, itemForPage) {
   if (itemForPage >= items) {
      $('.videoItem-loadmore').hide();
   }
}